// extracted by mini-css-extract-plugin
export var cell = "_4t-4";
export var headerCell = "_4t-2";
export var rowHeader = "_4t-3";
export var table = "_4t-1";
export var tableContainer = "_4t-0";